function readOne(value) {
  switch (value) {
    case 0:
      return "";
    case 1:
      return "một";
    case 2:
      return "hai";
    case 3:
      return "ba";
    case 4:
      return "bốn";
    case 5:
      return "năm";
    case 6:
      return "sáu";
    case 7:
      return "bảy";
    case 8:
      return "tám";
    case 9:
      return "chín";
    default:
      return "không";
  }
}

function readTwo(value) {
  if (value == 0) return "";
  else if (value < 10) return "linh" + " " + readOne(value);
  else if (value == 10) return "mười";
  else if (value == 11) return "mười một";
  else if (value == 15) return "mười lăm";
  else if (value < 20) return "mười" + " " + readOne(value % 10);
  else if (value % 10 == 0) return readOne(parseInt(value / 10)) + " mươi";
  else if (value % 10 == 5) return readOne(parseInt(value / 10)) + " mươi lăm";
  else if (value % 10 == 1) return readOne(parseInt(value / 10)) + " mươi mốt";
  else return readOne(parseInt(value / 10)) + " mươi " + readOne(value % 10);
}

function readThree(value) {
  if (value == 0) return '';
  else if (value < 10) return "không trăm linh" + " " + readOne(value % 100);
  else if (value < 100) return "không trăm" + " " + readTwo(value % 100);
  else return readOne(parseInt(value / 100)) + " trăm " + readTwo(value % 100);
}

function parse(value, content) {
  if(value != '') return value + content;
  else return ''
}

export default function read(value) {
  let billion = 0;
  let thousand = 0;
  let million = 0;
  let unit = 0;
  billion = parseInt(value / 1000000000);
  million = parseInt((value % 1000000000) / 1000000);
  thousand = parseInt((value % 1000000) / 1000);
  unit = value % 1000;
  let result = "";

  if (value < 1000) {
    billion = 0;
    thousand = 0;
    million = 0;
    unit = 0;
  }
  if (billion > 0 && billion < 10)
    result =
      readOne(billion) +
      " tỷ " +
      parse(readThree(million), " triệu ") +
      parse(readThree(thousand), " nghìn ") +
      readThree(unit);
  else if (billion > 0 && billion < 100)
    result =
      readTwo(billion) +
      " tỷ " +
      parse(readThree(million), " triệu ") +
      parse(readThree(thousand), " nghìn ") +
      readThree(unit);
  else if (billion > 0 && billion < 1000)
    result =
      readThree(billion) +
      " tỷ " +
      parse(readThree(million), " triệu ") +
      parse(readThree(thousand), " nghìn ") +
      readThree(unit);
  else if (million > 0 && million < 10)
    result =
      readOne(million) +
      " triệu " +
      parse(readThree(thousand), " nghìn ") +
      readThree(unit);
  else if (million > 0 && million < 100)
    result =
      readTwo(million) +
      " triệu " +
      parse(readThree(thousand), " nghìn ") +
      readThree(unit);
  else if (million > 0 && million < 1000)
    result =
      readThree(million) +
      " triệu " +
      parse(readThree(thousand), " nghìn ") +
      readThree(unit);
  else if (thousand > 0 && thousand < 10)
    result = readOne(thousand) + " nghìn " + readThree(unit);
  else if (thousand > 0 && thousand < 100)
    result = readTwo(thousand) + " nghìn " + readThree(unit);
  else if (thousand > 0 && thousand < 1000)
    result = readThree(thousand) + " nghìn " + readThree(unit);
  else if (unit > 0 && unit < 10) result = readOne(unit);
  else if (unit > 0 && unit < 100) result = readTwo(unit);
  else if (unit > 0 && unit < 1000) result = readThree(unit);
  result = result.charAt(0).toUpperCase() + result.slice(1);
  return result + ' đồng';
}
